import { useQuery } from '@tanstack/react-query';

import {
  GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
  getHealthGoalPrograms,
} from '@leagueplatform/health-journey-api';

export const useHealthGoalPrograms = () =>
  useQuery([GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE], getHealthGoalPrograms);
